import { render, staticRenderFns } from "./SectionGroupsList.vue?vue&type=template&id=70029e7d"
import script from "./SectionGroupsList.vue?vue&type=script&lang=js"
export * from "./SectionGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports